export default __webpack_public_path__ + "static/9-cca03cea2d9907be60851c3f4bf5a4c0.png";